import React from 'react';
import { motion } from 'framer-motion';
import { Settings, ShieldCheck, TreeDeciduous, Users, Sparkles, Award, CheckCircle ,Hammer } from 'lucide-react';
import './HowWeWork.css';
import Craftman from '../Craftman.png';
import Craftmanm from '../Craftmanm.jpg';
const WorkAndCert = () => {
  const processPoints = [
    {
      title: "Quality Control",
      desc: "We have a team of quality controllers that continuously follow the production process to ensure flawlessness.",
      icon: <Settings size={30} />
    },
    {
      title: "Comfort & Durability",
      desc: "Products are designed for maximum comfort, built for sturdy durability and finished for long-lasting protection.",
      icon: <Sparkles size={30} />
    },
    {
      title: "Solid Hardwood",
      desc: "Constructed of 100% solid hardwood; no particle board, laminates, or fillers. Only the purest timber.",
      icon: <TreeDeciduous size={30} />
    },
    {
      title: "Quality Guaranteed",
      desc: "Our products & services will meet your highest quality requirements without compromise.",
      icon: <ShieldCheck size={30} />
    },
    {
      title: "Personalized Needs",
      desc: "Our present goal is to personalize our service to meet the specific needs of each and every customer.",
      icon: <Users size={30} />
    },
    {
  title: "Expert Craftsmanship",
  desc: "Every piece is handcrafted by skilled artisans, combining traditional techniques with modern precision.",
  icon: <Hammer size={30} />
}

  ];

  return (
    <div className="main-wrapper">
      
      {/* SECTION 1: HOW WE WORK (STUNNING PROCESS GRID) */}
      <section className="pwc-process-section">
        <div className="pwc-container">
          <div className="pwc-header">
            <h2 className="pwc-title">How Do We Work?</h2>
            <p className="pwc-subtitle">A journey from raw timber to a masterpiece in your home.</p>
            <div className="pwc-divider"></div>
          </div>

          <div className="pwc-grid">
            {processPoints.map((item, index) => (
              <motion.div 
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                viewport={{ once: true }}
                className="pwc-card"
              >
                <div className="pwc-card-number">0{index + 1}</div>
                <div className="pwc-icon-box">{item.icon}</div>
                <h3 className="pwc-card-title">{item.title}</h3>
                <p className="pwc-card-desc">{item.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* SECTION 2: CERTIFICATES (EYE-CATCHING VISUAL GALLERY) */}
      <section className="vce-cert-section">
        <div className="vce-container">
          <div className="vce-content-box">
            <span className="vce-pre-title">Trust & Excellence</span>
            <h2 className="vce-main-title">Certified Craftsmanship</h2>
            <p className="vce-para">
              Our commitment to quality is backed by international standards. 
              We are proud to hold certifications that validate our use of 
              sustainable wood and ethical labor practices.
            </p>
            
            <ul className="vce-list">
              <li><CheckCircle size={18} className="vce-check"/> ISO 9001 Quality Management</li>
              <li><CheckCircle size={18} className="vce-check"/> FSC Sustainable Forest Certified</li>
              <li><CheckCircle size={18} className="vce-check"/> Premium Artisan Guild Member</li>
            </ul>
          </div>

          <div className="vce-visual-box">
            <div className="vce-image-stack">
              {/* Image 1 */}
              <motion.div 
                whileHover={{ scale: 1.05, rotate: -2, zIndex: 10 }}
                className="vce-img-wrapper vce-img-1"
              >
                <img src={Craftman} alt="Certification 1" />
                <div className="vce-glass-overlay">
                    <Award color="white" size={40}/>
                </div>
              </motion.div>

              {/* Image 2 */}
              <motion.div 
                whileHover={{ scale: 1.05, rotate: 2, zIndex: 10 }}
                className="vce-img-wrapper vce-img-2"
              >
                <img src={Craftmanm} alt="Certification 2" />
                <div className="vce-glass-overlay">
                    <CheckCircle color="white" size={40}/>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default WorkAndCert;